// import { ThemeProvider } from '@material-ui/styles';
// import theme from './app/theme';

import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { hydrate } from 'react-dom';
import { ThemeProvider } from '@material-ui/styles';


import App from './app';
import { resume } from './app/modules/actions/session';
import configureStore from './app/modules/store';

import theme from './app/theme';

const store = configureStore(window.__PRELOADED_STATE__);

const init = async () => {
  await store.dispatch(resume());
};

init();

hydrate(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </ThemeProvider>,
  document.getElementById('root'),
  () => {
    // [ReHydratation](https://github.com/cssinjs/jss/blob/master/docs/ssr.md)
    const jssStyles = document.getElementById('jss-ssr');

    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }
);

if (module.hot) {
  module.hot.accept();
}
